export default __webpack_public_path__ + "static/media/B_05_04_bg.fe75e4c2.mp4";